var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "content-new-video", class: "layout-" + _vm.layout },
    [
      _c("div", { staticClass: "video-container" }, [
        _c("div", { staticClass: "video-wrapper" }, [
          _c("video", {
            staticClass: "responsive-video",
            attrs: {
              src: _vm.videoUrl,
              playsinline: "",
              preload: "metadata",
              controls: "",
              poster: _vm.thumbnailUrl
            },
            on: {
              click: function($event) {
                return _vm.toggleOverlay(1)
              }
            }
          }),
          _vm._v(" "),
          _vm.overlayIndex === 1
            ? _c(
                "div",
                {
                  staticClass: "video-overlay",
                  on: {
                    click: function($event) {
                      return _vm.toggleOverlay(0)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "overlay-content" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close-button",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleOverlay(0)
                          }
                        }
                      },
                      [_vm._v("×")]
                    ),
                    _vm._v(" "),
                    _c("video", {
                      staticClass: "fullscreen-video",
                      attrs: { src: _vm.videoUrl, controls: "", autoplay: "" }
                    })
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("figcaption", { staticClass: "video-info" }, [
        _c("h3", { staticClass: "video-title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("div", {
          staticClass: "video-description",
          domProps: { innerHTML: _vm._s(_vm.description) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb1eafda", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb1eafda","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/content/ContentNewVideo.vue
// module id = 576
// module chunks = 0